module.exports = "<div class=start-button hm-tap=$ctrl.onClick()> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/start-button/start-button.html
 ** module id = 89
 ** module chunks = 0
 **/